import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ChartContainer } from './styles';
import { ACTIVE_CHATS_TITLE, DEALS_CLOSED_TITLE, STARTED_MESSAGES_TITLE, UNREAD_MESSAGES_TITLE, CALLS_MADE_TITLE, CALLS_WITH_ANSWER_TITLE} from './hooks/utils';

export const Chart = ( { dashboardData, negotiatorsData } ) => {
	// Calcular somatórias dos negociadores
	const negotiatorsTotals = negotiatorsData?.reduce(
		( acc, negotiator ) => ( {
			activeChats     : acc.activeChats + ( negotiator.activeChats || 0 ),
			dealsClosed     : acc.dealsClosed + ( negotiator.dealsClosed || 0 ),
			startedMessages : acc.startedMessages + ( negotiator.startedMessages || 0 )
		} ),
		{ activeChats: 0, dealsClosed: 0, startedMessages: 0 }
	) || { activeChats: 0, dealsClosed: 0, startedMessages: 0 };

	// Preparar dados para o gráfico
	const chartData = [
		{
			name         : DEALS_CLOSED_TITLE,
			IA           : dashboardData?.totalDealsClosedByIA || 0,
			Negociadores : negotiatorsTotals.dealsClosed
		},
		{
			name         : STARTED_MESSAGES_TITLE,
			IA           : dashboardData?.totalStartedMessagesJarvis || 0,
			Negociadores : negotiatorsTotals.startedMessages
		},
		{
			name         : ACTIVE_CHATS_TITLE,
			IA           : dashboardData?.totalActiveChatsJarvis || 0,
			Negociadores : negotiatorsTotals.activeChats
		},
		{
			name         : UNREAD_MESSAGES_TITLE,
			IA           : dashboardData?.totalUnreadCountJarvis || 0,
			Negociadores : dashboardData?.totalUnreadCountNegotiators || 0
		},
		{
			name         : CALLS_MADE_TITLE,
			IA           : dashboardData?.totalCallsMadeByIA || 0,
			Negociadores : dashboardData?.totalCallsMadeByNegotiators || 0
		},
		{
			name         : CALLS_WITH_ANSWER_TITLE,
			IA           : dashboardData?.totalCallsMadeByIAWithAnswer || 0,
			Negociadores : dashboardData?.totalCallsMadeByNegotiatorsWithAnswer || 0
		}
	];

	const CustomTooltip = ( { active, payload, label } ) => {
		if ( active && payload && payload.length ) {
			return (
				<div style={{
					backgroundColor : 'white',
					border          : '1px solid #ccc',
					borderRadius    : '4px',
					padding         : '16px',
					boxShadow       : '0 2px 4px rgba(0,0,0,0.1)'
				}}>
					<p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>{label}</p>
					{payload.map( ( entry, index ) => (
						<p key={index} style={{
							margin   : '4px 0',
							color    : entry.color,
							fontSize : '14px'
						}}>
							{entry.dataKey}: {entry.value}
						</p>
					) )}
				</div>
			);
		}
		return null;
	};

	const getLabelLines = ( label ) => {
		if ( label === CALLS_MADE_TITLE ) return [ 'Chamadas', 'realizadas' ];
		if ( label === CALLS_WITH_ANSWER_TITLE ) return [ 'Chamadas que resultaram', 'em resposta' ];
		return [ label ];
	};

	const LINE_HEIGHT = 14;

	const CustomXAxisTick = ( { x, y, payload } ) => {
		const lines = getLabelLines( payload?.value );
		return (
			<g transform={`translate(${x},${y})`}>
				<text textAnchor="middle" fill="#666" fontSize={12} style={{ fontWeight: 500 }}>
					{lines.map( ( line, i ) => (
						<tspan key={i} x={0} dy={i === 0 ? 16 : LINE_HEIGHT}>
							{line}
						</tspan>
					) )}
				</text>
			</g>
		);
	};
	return (
		<ChartContainer>
			<div className='ChartSection'>
				<h3 style={{ 
					margin     : '0 0 20px 0', 
					fontSize   : '18px', 
					fontWeight : '600',
					color      : '#333'
				}}>
				Funil de Performance - IA vs Negociadores
				</h3>
			
				<ResponsiveContainer width="100%" height={400}>
					<BarChart
						data={chartData}
						margin={{
							top    : 20,
							right  : 30,
							left   : 20,
							bottom : 45,
						}}
						barCategoryGap="20%"
					>
						<CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
						<XAxis
							dataKey="name"
							tick={<CustomXAxisTick />}
							axisLine={{ stroke: '#e0e0e0' }}
							interval={0}
						/>
						<YAxis 
							tick={{ fontSize: 12, fill: '#666' }}
							axisLine={{ stroke: '#e0e0e0' }}
						/>
						<Tooltip content={<CustomTooltip />} />
						<Legend 
							wrapperStyle={{ paddingTop: '20px' }}
							iconType="rect"
						/>
						<Bar 
							dataKey="IA" 
							fill="#0DA2E7" 
							name="IA"
							radius={[ 2, 2, 0, 0 ]}
							maxBarSize={60}
						/>
						<Bar 
							dataKey="Negociadores" 
							fill="#16A249" 
							name="Negociadores"
							radius={[ 2, 2, 0, 0 ]}
							maxBarSize={60}
						/>
					</BarChart>
				</ResponsiveContainer>
			</div>
		</ChartContainer>
	);
};
